<template>
  <div class="w-full pt-8 px-8 flex flex-col justify-center">
    <div
      :style="{ maxWidth: '350px' }"
      class="flex flex-col justify-center items-center m-auto"
    >
      <h5 class="mt-6 mb-1 text-truegray-500 text-xs">
        Select {{ TITLE_KEY }} for
        <span class="lowercase">{{ TYPE_FORMATTED }}</span> statistics
      </h5>
      <InputDropdown
        :selected-options-initial="[selectedOption]"
        :options="OPTIONS"
        :margin-bottom="false"
        :border-enabled="true"
        :shadow-enabled="false"
        :response-selection-id="'cw-contributor-input-dropdown-selected'"
      />

      <button
        :disabled="!canSubmit"
        :class="[
          !canSubmit ? 'opacity-25 cursor-not-allowed' : '',
          isSubmitting ? '' : '',
        ]"
        class="btn btn-cw-alt relative w-40 m-0 mt-8"
        @click="submit"
      >
        <div class="flex justify-center items-center w-full h-full">
          <div
            class="absolute inset-0 w-full flex justify-center items-center z-20"
          >
            <lottie v-if="isSubmitting" :options="loadingAnimationOptions" />
          </div>
          <div
            :class="[isSubmitting ? 'invisible' : '']"
            class="w-full flex items-center justify-center"
          >
            Refresh
          </div>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref, onMounted } from 'vue'
import { useStore } from '../../../../js/store/index.js'
import InputDropdown from '../../../../shared/components/InputDropdown.vue'
import {
  EVENT_KEYS,
  CD_STAT_TYPE_OPTIONS,
  ALL_REGIONS_TAG_ID,
  KEY_TYPE_REGION,
} from '../../../../js/util/constants.js'
import { checkPositiveInteger } from '../../../../js/util/helper.js'
import * as loadingAnimation from '../../../../shared/components/loading.json'
import { EventBus } from '../../../../js/plugins/event-bus'

export default defineComponent({
  name: 'ModalInputDropdownSelector',

  components: {
    InputDropdown,
  },

  props: {
    config: { default: null },
  },

  setup(props) {
    const store = useStore()

    const TYPE = props.config?.type || null
    const TITLE_KEY = CD_STAT_TYPE_OPTIONS[TYPE].TYPE
    const TYPE_FORMATTED = TYPE?.replace('_', ' ') || ''
    const IS_REGION_SELECTOR =
      CD_STAT_TYPE_OPTIONS[TYPE].TYPE === KEY_TYPE_REGION
    const OPTIONS = props.config?.options || []

    const selectedOption = ref(props.config?.selectedOption || 0)
    const isSubmitting = ref(false)
    const canSubmit = computed(() => {
      return true
    })

    const dispatchAction = async () => {
      const action = CD_STAT_TYPE_OPTIONS[TYPE].ACTION

      if (action) {
        const key = CD_STAT_TYPE_OPTIONS[TYPE].KEY_PAYLOAD

        const hasPayload =
          // region selector value must not be 'All Regions' (99), but may be 0
          (IS_REGION_SELECTOR &&
            checkPositiveInteger(selectedOption.value) &&
            selectedOption.value !== ALL_REGIONS_TAG_ID) ||
          // date range selector value must not be 'All time' (0)
          (!IS_REGION_SELECTOR && selectedOption.value)

        const payload = hasPayload
          ? {
              [key]: selectedOption.value,
            }
          : null

        await store.dispatch(`contributors/${action}`, payload)
      }
    }

    const submit = async () => {
      isSubmitting.value = true
      await dispatchAction()

      isSubmitting.value = false
      EventBus.$emit(EVENT_KEYS.CD_INPUT_DROPDOWN_UPDATED, {
        type: TYPE,
        value: selectedOption.value,
      })
    }

    onMounted(() => {
      EventBus.$on('cw-contributor-input-dropdown-selected', (val) => {
        selectedOption.value = val
      })
    })

    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      TITLE_KEY,
      TYPE_FORMATTED,
      OPTIONS,
      selectedOption,
      isSubmitting,
      canSubmit,
      submit,
    }
  },
})
</script>
